function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var GameObserverLoaderTemplate = require('./game-observer-loader.template');

/**
 * Loader/sync overlay component for the game observer.
 * - Renders into this.container (set in constructor). If container not provided, uses document.body.
 * - Replaces existing #observer-sync-overlay if present. No engine state mutation, no sync logic.
 *
 * @param {Object} app - Saito application.
 * @param {Object} game_mod - Game module (stored for optional use by consumers; this class does not mutate it).
 * @param {Element|string} [container=""] - DOM element to own; if falsy, document.body.
 */
var GameObserverLoader = /*#__PURE__*/function () {
  function GameObserverLoader(app, game_mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var observer = arguments.length > 3 ? arguments[3] : undefined;
    _classCallCheck(this, GameObserverLoader);
    this.app = app || null;
    this.game_mod = game_mod || null;
    this.observer = observer || null;
    this.container = container || (typeof document !== 'undefined' ? document.body : null);
  }
  return _createClass(GameObserverLoader, [{
    key: "render",
    value: function render() {
      if (!this.container || typeof document === 'undefined') {
        return;
      }
      var html = GameObserverLoaderTemplate();
      if (!html || !html.trim()) {
        return;
      }
      var hud = this.container.querySelector('#game-observer-hud');
      var existing = this.container.querySelector('#observer-sync-overlay');
      var wrap = document.createElement('div');
      wrap.innerHTML = html.trim();
      var node = wrap.firstElementChild;
      if (!node) return;
      if (existing) {
        existing.replaceWith(node);
      } else {
        this.container.appendChild(node);
      }
      if (existing && hud) {
        var hudZ = parseInt(window.getComputedStyle(hud).zIndex) || 0;
        existing.style.zIndex = hudZ + 1;
      }
      console.log('[OBS_TRACE] Loader.render() called; overlay in DOM:', !!this.container.querySelector('#observer-sync-overlay'));
    }

    /**
     * Hide the overlay with display:none in this.container.
     */
  }, {
    key: "hide",
    value: function hide() {
      if (!this.container || typeof document === 'undefined') {
        return;
      }
      var overlay = this.container.querySelector('#observer-sync-overlay');
      if (overlay) {
        overlay.style.display = 'none';
        console.log('[OBS_TRACE] Loader.hide() called');
      }
    }

    /**
     * Remove #observer-sync-overlay from this.container.
     */
  }, {
    key: "remove",
    value: function remove() {
      if (!this.container || typeof document === 'undefined') {
        return;
      }
      var overlay = this.container.querySelector('#observer-sync-overlay');
      if (overlay) {
        overlay.remove();
        console.log('[OBS_TRACE] Loader.remove() called; overlay removed from DOM');
      }
      if (this.container.querySelector('#observer-sync-overlay')) {
        console.warn('[Loader] existence check after remove: element still in DOM');
      }
    }

    /**
     * Update the sync status text inside the overlay. No-op if overlay not in this.container.
     *
     * @param {string} message - Status message to display.
     */
  }, {
    key: "updateStatus",
    value: function updateStatus(message) {
      if (!this.container || message == null) return;
      var el = this.container.querySelector('#observer-sync-status');
      if (el) el.innerText = message;
    }
  }]);
}();
module.exports = GameObserverLoader;